/* unplugin-vue-components disabled */import { render } from "./lookup-select.vue?vue&type=template&id=272ae04b"
import script from "./lookup-select.vue?vue&type=script&lang=js"
export * from "./lookup-select.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__